module.exports = "/img/profile.svg?ef729871e73d78c97322a07cf0e8f3f1";